global.toggleTarget = new function() {
    this.toggle = function(e) {
        e.preventDefault();

        const target = $(e.target);

        $('#' + target.data('target-id')).toggle();

        if(target.hasClass('toggle_plus')) {
            target
                .removeClass('toggle_plus')
                .addClass('toggle_minus');
        }
        else {
            target
                .removeClass('toggle_minus')
                .addClass('toggle_plus');
        }
    }
};
